import {
  Button,
  Form,
  Input,
  Card,
  notification,
  Space,
  Typography
} from 'antd'
import { LockOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { useAuthStore } from 'src/store/auth'
import { useEffect, useState } from 'react'

import './ResetPasswordForm.css'

const { Text } = Typography

const ResetPasswordForm = () => {
  const [form] = Form.useForm()
  const passwordValue = Form.useWatch('password_confirmation', form)
  const confirmPasswordValue = Form.useWatch('password', form)
  const [api, contextHolder] = notification.useNotification()
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const { resetPassword } = useAuthStore((store) => store)

  const queryParameters = new URLSearchParams(window.location.search)
  const token = queryParameters.get("token")

  const onFinish = async (values) => {
    const res = await resetPassword({ ...values, token })
    if (!res?.success) {
      if (res?.errors) {
        const ErrorsBody = () => (
          <Space direction={'vertical'}>
            {res?.errors &&
              res?.errors.map((error) => <Text type='danger'>{error}</Text>)}
          </Space>
        )

        api.error({
          message: `Reset Password Error`,
          description: <ErrorsBody />,
          placement: 'topRight'
        })
      } else {
        api.error({
          message: `Reset Password Error`,
          description: res?.error || 'Error',
          placement: 'topRight'
        })
      }

      setError(res)
    } else {
      api.success({
        message: `Reset Password Success`,
        description: res?.message || '',
        placement: 'topRight'
      })
      setSuccess(true)
    }
  }

  const onFinishFailed = (errorInfo) => {}

  useEffect(() => {
    setError(null)
  }, [passwordValue, confirmPasswordValue])

  return (
    <Card
      title='Reset Password'
      style={{
        maxWidth: 400,
        width: '100%'
      }}
      headStyle={{
        textAlign: 'center',
        fontSize: '30px',
        padding: '20px'
      }}
    >
      {contextHolder}
      {!success ? (
        <Form
          form={form}
          className='clear-form'
          layout='vertical'
          name='basic'
          style={{
            maxWidth: 400,
            width: '100%'
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          {error && (
            <Space direction={'vertical'} style={{ marginBottom: 15 }}>
              {error?.errors ? (
                error?.errors.map((error) => <Text type='danger'>{error}</Text>)
              ) : (
                <Text type='danger'>{error?.error}</Text>
              )}
            </Space>
          )}
          <Form.Item
            name='password'
            label='Password'
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password
              prefix={<LockOutlined className='site-form-item-icon' />}
              type='password'
              placeholder='Password'
            />
          </Form.Item>

          <Form.Item
            name='password_confirmation'
            label='Confirm Password'
            rules={[
              { required: true, message: 'Please input your confirm password!' }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className='site-form-item-icon' />}
              type='password'
              placeholder='Confirm password'
            />
          </Form.Item>

          <Form.Item style={{ paddingTop: 15 }}>
            <Button
              type='primary'
              block
              htmlType='submit'
              className='login-form-button'
            >
              Reset password
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <Space style={{ width: '100%', justifyContent: 'center' }}>
          <Text type='success'>Password updated!</Text>
          <Link to={'/sign-in'}>Sign In</Link>
        </Space>
      )}
    </Card>
  )
}
export default ResetPasswordForm
